<template>
    <div :class="isEditing ? '' : 'card card-default'">
        <div v-if="!isEditing" class="card-header">
            <div class="d-inline-block card-header-content">
                <div class="title">{{ title }}</div>
            </div>
            <div class="d-inline-block float-right">
            </div>
        </div>
        <div class="card-body">

            <div class="alert alert-danger" v-if="error">
                {{ errorMessage }}
            </div>

            <form role="form">
                <label class="col-md-3 col-form-label text-muted mb-3">REQUIRED</label>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">Project name</label>

                    <div class="col-md-8">
                        <input v-model="form.name" type="text" class="form-control" name="name" autofocus :class="{'is-invalid': form.errors.has('name')}" />
                        <span class="invalid-name" v-show="form.errors.has('name')">
                            @{{ form.errors.get('name') }}
                        </span>
                    </div>
                </div>

                <hr>
                <label class="col-md-3 col-form-label text-muted mb-3">OPTIONAL</label>

                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">Address</label>

                    <div class="col-md-8">
                        <input v-model="form.address" placeholder="Address" type="text" class="form-control mb-2" name="address" />
                        <input v-model="form.address2" placeholder="Address 2" type="text" class="form-control mb-2" name="address2" />
                        <input v-model="form.city" placeholder="City" type="text" class="form-control mb-2" name="city" />
                        <div class="row">
                            <div class="col-md-6">
                                <input v-model="form.state" placeholder="State/Province" type="text" class="form-control mb-2" name="state" />
                            </div>
                            <div class="col-md-6">
                                <input v-model="form.country" placeholder="Country" type="text" class="form-control mb-2" name="country" />
                            </div>
                        </div>
                        <input v-model="form.zip" placeholder="ZIP/Postal" type="text" class="form-control" name="zip" />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">Job site access code</label>

                    <div class="col-md-4">
                        <input v-model="form.accessCode" type="text" class="form-control" name="name" autofocus />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">Estimated dates</label>

                    <div class="col-md-8">
                        <div class="row no-gutters">
                            <div class="col-md-5">
                                <!-- <date-picker-wrapper :placeholder="'Start date'" :date="startDate" @selected-date="startDate = $event"></date-picker-wrapper> -->

                                <date-picker-wrapper :date="dateFromString(startDate)" :placeholder="'Start Date'" :onClear="clearStartDate" @selected-date="startDate = $event" :not-before="null"></date-picker-wrapper>

                            </div>
                            <div class="col-md-2 col-form-label text-center">
                                until
                            </div>
                            <div class="col-md-5">
                                <!-- <date-picker-wrapper :placeholder="'End date'" :date="endDate" :not-before="startDate" @selected-date="endDate = $event"></date-picker-wrapper> -->
                                <date-picker-wrapper :date="dateFromString(endDate)" :placeholder="'End date'" :onClear="clearEndDate" :not-before="startDate" @selected-date="endDate = $event" :error="form.errors.has('endDate')"></date-picker-wrapper>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">Contract price</label>

                    <div class="col-md-8">
                        <div class="row no-gutters">
                            <div class="col-md-5">
                                <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">$</span>
                                      </div>
                                      <input v-model="form.estimate" type="number" class="form-control" name="estimate" />
                                </div>
                            </div>
                            <div class="col-md-2 col-form-label text-center">
                                Tax
                            </div>
                            <div class="col-md-3">
                                <div class="input-group">
                                      <input v-model="form.tax" type="number" class="form-control" name="estimate" />
                                      <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2">%</span>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!firstProject" class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">Foreman</label>
                    <div class="col-md-8">

                        <select class="form-control minimal" v-model="foreman">
                            <option value="none">None</option>
                            <option v-for="crewMember in crew" v-bind:value="crewMember">{{ crewMember.name }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">Notes</label>

                    <div class="col-md-8">
                        <textarea v-model="form.notes" type="text" rows="5" class="form-control" name="notes"></textarea>
                    </div>
                </div>

                <!--
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">Image</label>

                    <div class="col-md-4">
                        <button type="button" class="btn btn-secondary">Upload image</button>
                    </div>
                </div>
                 -->

                 <div class="form-group row">
                     <div class="col-md-8 offset-md-3">
                         <hr />
                         <div class="new-change-order-note">Once you create your project, you'll be able to create work orders, add customers, and more.</div>
                     </div>
                 </div>

                <div class="form-group row mb-0">
                    <div class="col-md-8 offset-md-3">
                        <button type="button" class="btn btn-primary" @click="submit"
                        :disabled="form.busy">{{ saveButtonTitle }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['firstProject', 'project', 'isEditing'],

        created: function() {
            this.getCrew();
        },

        mounted: function() {

        },

        watch: {
            startDate: function(newVal, oldVal) {
                this.form.startDate = newVal;
            },

            endDate: function(newVal, oldVal) {
                this.form.endDate = newVal;
            },
        },

        data: function() {
            return {
                form: new SparkForm({
                    name: this.project && this.project.name ? this.project.name : '',
                    address: this.project && this.project.address ? this.project.address : '',
                    address2: this.project && this.project.address2 ? this.project.address2 : '',
                    city: this.project && this.project.city ? this.project.city : '',
                    state: this.project && this.project.state ? this.project.state : '',
                    country: this.project && this.project.country ? this.project.country : '',
                    zip: this.project && this.project.zip ? this.project.zip : '',
                    startDate: this.project && this.project.start_date ? this.project.start_date : null,
                    endDate: this.project && this.project.end_date ? this.project.end_date : null,
                    notes: this.project && this.project.notes ? this.project.notes : '',
                    estimate: this.project && this.project.estimate ? this.project.estimate : null,
                    tax: this.project && this.project.tax ? this.project.tax : null,
                    image: this.project && this.project.image ? this.project.image : '',
                    accessCode: this.project && this.project.site_access_code ? this.project.site_access_code : '',
                }),
                error: false,
                errorMessage: '',
                startDate: this.project && this.project.start_date ? this.project.start_date : null,
                endDate: this.project && this.project.end_date ? this.project.end_date : null,

                //Foreman dropdown
                loadingCrew: true,
                crew: [],
                foreman: 'none',
            };
        },

        computed: {
            title: function() {
                if (this.form.name.length > 0) {
                    return this.form.name;
                }
                return 'New project';
            },

            crewInputPlaceholder: function() {
                if (this.loadingCrew) {
                    return 'Loading team members...';
                }
                return 'Search team members';
            },

            saveButtonTitle: function() {
                if (this.isEditing) {
                    return "Save changes";
                }

                return "Create project";
            },

            hasForeman: function() {
                return this.foreman && this.foreman != 'none';
            },
        },

        methods: {
            clearStartDate: function() {
                this.form.startDate = null;
            },

            clearEndDate: function() {
                this.form.endDate = null;
            },

            dateFromString: function(dateString) {
                if (dateString) {
                    return moment(dateString).toDate();
                }
                return null;
            },

            resetForm: function() {
                this.form = new SparkForm({
                    name: this.project && this.project.name ? this.project.name : '',
                    address: this.project && this.project.address ? this.project.address : '',
                    address2: this.project && this.project.address2 ? this.project.address2 : '',
                    city: this.project && this.project.city ? this.project.city : '',
                    state: this.project && this.project.state ? this.project.state : '',
                    country: this.project && this.project.country ? this.project.country : '',
                    zip: this.project && this.project.zip ? this.project.zip : '',
                    startDate: this.project && this.project.startDate ? this.project.startDate : null,
                    endDate: this.project && this.project.endDate ? this.project.endDate : null,
                    notes: this.project && this.project.notes ? this.project.notes : '',
                    estimate: this.project && this.project.estimate ? this.project.estimate : null,
                    tax: this.project && this.project.tax ? this.project.tax : null,
                    image: this.project && this.project.image ? this.project.image : '',
                    accessCode: this.project && this.project.site_access_code ? this.project.site_access_code : '',
                    startDate:  this.project && this.project.start_date ? this.project.start_date : null,
                    endDate:  this.project && this.project.end_date ? this.project.end_date : null,
                });
                this.foreman = 'none';
                this.startDate = this.project && this.project.startDate ? this.project.startDate : null;
                this.endDate = this.project && this.project.endDate ? this.project.endDate : null;
            },

            cancelForm: function() {
                Bus.$emit('new-project-canceled');
            },

            projectUpdated: function(response) {
                Bus.$emit('project-updated', response);
                //Bus.$emit('refresh-current-project');
            },

            submit: function() {
                this.error = false;
                if (this.hasForeman) {
                    this.form.foreman = this.foreman;
                }
                if (this.isEditing) {
                    Spark.put(`/api/projects/${this.project.id}`, this.form)
                        .then(response =>
                        {
                            this.projectUpdated(response);
                            /*mixpanel.track('Project Updated', {
                                name: response.name,
                            });*/
                        })
                        .catch(error => {
                            this.error = true;
                            this.errorMessage = error.error;
                        });;
                }
                else {
                    Spark.post('/api/projects', this.form)
                        .then(response => {
                            this.resetForm();
                            Bus.$emit('project-created', response);
                            /*mixpanel.track('Project Created', {
                                name: response.name,
                            });*/
                        })
                        .catch(error => {
                            this.error = true;
                            this.errorMessage = error.error;
                        });
                }
            },

            loadForeman: function() {
                if (this.project && this.project.foreman) {
                    let crewMember = _.find(this.crew, crewMember => crewMember.id === this.project.foreman.id);
                    this.foreman = crewMember;
                }
            },

            getCrew: function()
            {
                axios.get(`/api/crew`)
                    .then(response =>
                    {
                        this.loadingCrew = false;
                        this.crew = response.data.crew;
                        this.loadForeman();
                    })
                    .catch(error =>
                    {
                        this.loadingCrew = false;
                    });
            },
        }
    }
</script>
